import { Button, AlertIcon, Toast } from '@diversioteam/diversio-ds'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { useDuplicatePulseSurvey } from 'hooks/pulseSurveys/useDuplicatePulseSurvey'

import * as S from './pulseSurveyError.styles'
import { PulseSurveyErrorProps } from './pulseSurveyError.types'

export const PulseSurveysError = ({ surveyUUID = '', isPreviewMode = false }: PulseSurveyErrorProps) => {
    const history = useHistory()

    const { mutate } = useDuplicatePulseSurvey()

    const handleDuplicateSurvey = () => {
        mutate({ survey: surveyUUID })
    }

    const handleRefresh = () => {
        history.go(0)
    }
    return (
        <S.ErrorContainer>
            {isPreviewMode && (
                <S.PreviewToastWrapper>
                    <Toast
                        open={true}
                        type="warning"
                        message="Preview mode. To make changes, duplicate it first."
                        icon={<AlertIcon type="line" />}
                        buttonLabel="Duplicate & Edit"
                        onClick={handleDuplicateSurvey}
                    />
                </S.PreviewToastWrapper>
            )}

            <S.HeaderToast isPreviewMode={isPreviewMode}>
                <S.ErrorContentWrapper>
                    <S.IconContainer>
                        <AlertIcon type="line" />
                    </S.IconContainer>
                    <S.ErrorMessage>Oops, something isn’t working. Please try again</S.ErrorMessage>
                </S.ErrorContentWrapper>
                <S.ButtonContainer>
                    <Button size="small" color="secondary" onClick={handleRefresh}>
                        Refresh
                    </Button>
                </S.ButtonContainer>
            </S.HeaderToast>

            <S.EmptyView>
                <S.StyledLogo />
            </S.EmptyView>
        </S.ErrorContainer>
    )
}
